import { useEffect, useState } from "react";
import { ActionIcon, Box, Group, Popover, Text } from "@mantine/core";
import { IconTrash } from "@tabler/icons-react";
import { ScenarioEvent, ScenarioEventInputData } from "../../../../types/assessments";
import { EventParameters } from "./EventParameters";

interface IEvent {
	event: ScenarioEvent;
	eventData: ScenarioEventInputData;
	setEvents: React.Dispatch<React.SetStateAction<ScenarioEvent[]>>;
}

export const Event: React.FC<IEvent> = ({ event, eventData, setEvents }) => {
	const [opened, setOpened] = useState(false);

	useEffect(() => {
		const handleScroll = () => {
			setOpened(false);
		};

		window.addEventListener("scroll", handleScroll, true); // useCapture = true to catch inner scrolls too
		return () => window.removeEventListener("scroll", handleScroll, true);
	}, []);

	return (
		<Popover position="bottom" withArrow opened={opened} onChange={setOpened} withinPortal>
			<Popover.Target>
				<Box
					pos="absolute"
					top={30}
					left={event.time * 100}
					w={event.duration * 100}
					h={120}
					bg="blue.2"
					style={{
						display: "flex",
						flexDirection: "column",
						justifyContent: "space-between",
						borderRadius: 4,
						padding: "4px 6px",
						overflow: "hidden",
						border: "1px solid #228be6",
						cursor: "pointer",
					}}
					sx={{
						"&:hover button": {
							opacity: 1,
							visibility: "visible",
						},
					}}
					onClick={() => setOpened((prev) => !prev)}
				>
					<Group position="right" spacing={0}>
						<ActionIcon
							color="red.3"
							size="xs"
							title="Remove Event"
							variant="transparent"
							onClick={() => {
								setEvents((prev) => prev.filter((e) => !(e.event_id === event.event_id && e.time === event.time)));
							}}
							sx={{
								alignSelf: "flex-end",
								opacity: 0,
								visibility: "hidden",
								transition: "opacity 0.2s ease, visibility 0.2s ease",
							}}
						>
							<IconTrash size={16} />
						</ActionIcon>
						<Text size="xs" fw={500} w={"100%"} lineClamp={3} title={eventData?.name || `Event ${event.event_id}`}>
							{eventData?.name || `Event ${event.event_id}`}
						</Text>
					</Group>
					<Text size="xs">
						{`${Math.floor(event.time)}:${((event.time % 1) * 60).toFixed(0).padStart(2, "0")} – ${Math.floor(
							event.time + event.duration
						)}:${(((event.time + event.duration) % 1) * 60).toFixed(0).padStart(2, "0")}`}
					</Text>
				</Box>
			</Popover.Target>

			<Popover.Dropdown>
				<EventParameters eventInformation={eventData} />
			</Popover.Dropdown>
		</Popover>
	);
};
